import { URL } from "@constant/constant";
import { ConnectedWallet } from "@goblinhunt/cosmes/wallet";
import { AlertUtils } from "@hooks/AlertHook";
import { useAuthClient } from "@hooks/BaaangggHook";
import axios from "axios";
import { CredentialRequest } from "baaanggg";
import { response } from "express";

export class ActionService {

    async get() {
        try {
            const token = localStorage.getItem("token"); // ⬅️ ambil dari localStorage
            if (token) {
                const response = await axios.get(`${URL}/me`,
                    {
                        headers: {
                            Authorization: `Bearer ${JSON.parse(token ?? "").accessToken}`, // ⬅️ masukin token di sini
                        }
                    }
                );
                return response.data;
            } else {
                return false
                // await signInCall()
            }
        } catch (error: any) {
            console.error("Error fetching users:", error.message);
            throw error;
        }
    }


    async checkRegis(address: string): Promise<boolean> {
        const response = await axios.get(`${URL}/user/is-registered/${address}`)
        return response.data.isRegistered
    }

    async signIn(
        alert: AlertUtils,
        wallet: ConnectedWallet, // ini instance dari cosmes
        address: string,
        onFailed: () => void
    ) {
        const token = localStorage.getItem("token"); // ⬅️ ambil dari localStorage
        console.log(token)
        if (token === null) {
            try {

                const reg = await this.checkRegis(address)
                // Pastikan sudah register
                if (!reg) throw "Account not registered yet"

                // Pesan HARUS persis kayak yang di-backend
                const msg = {
                    type: "/user/Authenticate",
                    address: address
                }
                const msgJson = JSON.stringify(msg);

                alert.loading("Request auth signing, please check your wallet")
                const result = await wallet.signArbitrary(msgJson);
                console.log(wallet.type)

                const credential: CredentialRequest = {
                    publicKey: result.pubKey,
                    signature: result.signature,
                    walletAddress: address,
                    walletType: wallet.type
                };

                const res = await axios.post(`${URL}/auth/sign-in`, credential)
                localStorage.setItem("token", JSON.stringify(res.data))
                alert.hide();

            } catch (e) {
            }
        }
    }

    async createAccount(
        username: string,
        address: string,
    ) {
        try {

            const res = await axios.post(`${URL}/auth/create-account`, { username, walletAddress:address })
            // localStorage.setItem("token", res.data)
            // alert.hide();
            console.log(res)

        } catch (e) {
        }
    }
}